import { render } from "./RegisteredTradesTopAreasReports.vue?vue&type=template&id=4a537ee2&ts=true"
import script from "./RegisteredTradesTopAreasReports.vue?vue&type=script&lang=ts"
export * from "./RegisteredTradesTopAreasReports.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__